import React, {ChangeEvent} from "react";
import {SearchContainer, SearchInput} from "./styles";
import {ReactComponent as SearchIcon} from '../../assets/icons/search.svg';

interface searchProps {
    placeholder: string,
    setSearchTerm: Function
}

export const SearchBox = ({placeholder, setSearchTerm } : searchProps) => {

    const handleChange = (e:ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)

    return <SearchContainer>
        <SearchIcon/>
        <SearchInput
            placeholder={placeholder}
            onChange={(e) => {handleChange(e)}}
        />
    </SearchContainer>
}
